/* global angular */

var isObjectName = require('../../../services/isObjectName')

angular.module('WcmDocumentDataserviceCmp', [])
  .factory('wcmDocumentDataservice', wcmDocumentDataservice)

wcmDocumentDataservice.$inject = ['contentService']

function wcmDocumentDataservice (contentService) {
  var fileContents = {}

  function getFileContents (formFields) {
    angular.forEach(formFields, function (item) {
      if (item.document) {
        if (isObjectName(item.document)) {
          fileContents[item.id] = { documentId: item.document }
        } else {
          fileContents[item.id] = { content: item.document }
        }
      }
      if (item.fields) {
        angular.forEach(item.fields, function (itemLevel2) {
          if (itemLevel2.document) {
            if (isObjectName(itemLevel2.document)) {
              fileContents[itemLevel2.id] = { documentId: itemLevel2.document }
            } else {
              fileContents[itemLevel2.id] = { content: itemLevel2.document }
            }
          }
          if (itemLevel2.fields) {
            angular.forEach(itemLevel2.fields, function (itemLevel3) {
              if (itemLevel3.document) {
                if (isObjectName(itemLevel3.document)) {
                  fileContents[itemLevel3.id] = { documentId: itemLevel3.document }
                } else {
                  fileContents[itemLevel3.id] = { content: itemLevel3.document }
                }
              }
            })
          }
        })
      }
    })

    Object.keys(fileContents).forEach(function (item) {
      if (fileContents[item].documentId) {
        contentService.getStaticHtml('internet', fileContents[item].documentId).promise
          .then(function (res) {
            fileContents[item].content = res.data
          })
      }
    })

    return fileContents
  }

  return {
    getFileContents: getFileContents
  }
}
